import { makeStyles } from '@material-ui/core/styles';
import typography from '@/theme/typography';
import { TextColors } from '@/utils/constants';
import { em } from '@/utils/helpers';

const darkTheme = {
  root: {
    '& .MuiTypography-root': {
      color: TextColors.light,
    },
  },
};

const lightTheme = {
  root: {
    '& .MuiTypography-root': {
      color: TextColors.dark,
    },
  },
};

const useStyles = makeStyles(
  (muiTheme) => ({
    root: {
      '&.dark-theme': darkTheme.root,
      '&.light-theme': lightTheme.root,
      display: 'flex',
      flexDirection: 'column',
      marginTop: muiTheme.spacing(3),

      [muiTheme.breakpoints.up('md')]: {
        marginTop: muiTheme.spacing(6),
      },
    },
    row: {
      [muiTheme.breakpoints.up('md')]: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        alignContent: 'flex-start',
      },
    },
    col: {
      [muiTheme.breakpoints.up('md')]: {
        flex: '1 1 50%',

        '&:first-child:not(:last-child)': {
          marginRight: '45px',
        },

        '&:last-child:not(:first-child)': {
          marginLeft: '45px',
        },
      },
    },
    logo: {
      alignSelf: 'flex-start',
      width: 'auto',
      maxHeight: '45px',
      marginBottom: em({ size: 16, base: 18 }),
    },
    headline: {
      '&.MuiTypography-root': {
        marginTop: 0,
        ...typography.h2,

        '&:not(:last-child)': {
          marginBottom: em({ size: 16, base: 36 }),
        },
      },
    },
    description: {
      '& + *:before': {
        content: '""',
        display: 'block',
        marginTop: '32px',
      },
    },
    buttons: {
      margin: '-10px',

      '& > *': {
        padding: '10px',
        display: 'inline-block',
      },
    },
  }),
  { name: 'GenCustomerStoryHeader' },
);

export default useStyles;
